<app-z-dialog
  [title]="data.title || 'Conta Corrente'"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentTemplate>
  <section class="current-account-dialog">
    <div class="current-account-dialog__summary">
      <div>
        <span class="current-account-dialog__label">Investidor</span>
        <strong>{{ data.investorName || '-' }}</strong>
      </div>
      <div>
        <span class="current-account-dialog__label">ID</span>
        <strong>{{ data.investorId || '-' }}</strong>
      </div>
      <div>
        <span class="current-account-dialog__label">Contas cadastradas</span>
        <strong>{{ formGroup.controls.bankAccounts.value.length }}</strong>
      </div>
    </div>

    <app-widget-data-list
      [formControlRef]="formGroup.controls.bankAccounts"
      [formDialog]="bankAccountFormDialog"
      [columns]="tableColumns"
      (dialogOpened)="lockBankField()"
      (dialogClosed)="resetBankAccountForm()"
    >
    </app-widget-data-list>
  </section>
</ng-template>

<ng-template #buttonsTemplate>
  <z-button
    [label]="'COMMON.SAVE' | translate"
    [icon]="'check_circle'"
    (clicked)="save()"
  ></z-button>
</ng-template>